<div class="p-grid" style="margin: 15px;">
    <p-panel header="LISTE DES PTL EN ATTENTE DE VALIDATION" class="p-col-12" styleClass="cq" > 
        <p-table #dt [columns]="attenteCols" [value]="attente" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <div class="ui-inputgroup recherche" >
                        <span class="ui-inputgroup-addon">Rechercher :</span>
                        <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
                    </div>
                </div>
            </ng-template>
            
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of attenteCols" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{moderation[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>

    <p-panel header="LISTE DES PTL VALIDES" class="p-col-12" styleClass="cq" > 
        <p-table #dt [columns]="valideCols" [value]="valide" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <div class="ui-inputgroup recherche" >
                        <span class="ui-inputgroup-addon">Rechercher :</span>
                        <input type="text" pInputText size="37" placeholder="Filtre globale" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto; min-height:35px;">
                    </div>
                </div>
            </ng-template>
            
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of valideCols" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{moderation[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>
</div>
